import { gql } from '@apollo/client';

export const GET_ORG_AFFILIATION = gql`
  query AAA_SERVICE_getOrgAffiliationV2 {
    getOrgAffiliationV2
  }
`;
